import get from 'lodash.get';
import getConfig from 'next/config';
import { useState } from 'react';

/*
 * Returns the publicRuntimeConfig value at `path`.
 */
export const getPublicRuntimeConfigValue = <T>(path: string) =>
  get(getConfig(), `publicRuntimeConfig.${path}`) as T;

/*
 * React hook which wraps `getPublicRuntimeConfigValue`.
 *
 * It's not always necessary to use this hook when using config
 * in React components - since config doesn't change at runtime,
 * if your tests don't need to test different config values
 * pulling the config in at the top of the file using
 * `getPublicRuntimeConfigValue` is fine.
 */
export const usePublicRuntimeConfigValue = <T>(path: string) => {
  const [value] = useState<T>(getPublicRuntimeConfigValue(path));

  return value;
};
